import React from "react";
// @ts-ignore
import DatetimeUtils from "src/core/gd/utils/datetime-utils";
import formatDate from "../../../../../../gd/format/date";

export default function FieldDate_InlineValueNotEmpty(props:any) {

    const onDeleteClick = () => {
        props.onChange(null);
    }

    return (
        <React.Fragment>

            <div className="ui5-field-with-delete-on-hover">
                <div className="ui5-field-dropdown-inline-editable" onClick={props.onClick}>
                    {_.get(props.field.components, 'ValueIcon', false)}
                    {props.value && formatDate(DatetimeUtils.dateToMoment(props.value))}
                </div>

                {props.field.clearButton && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}
            </div>



            {props.children}
        </React.Fragment>
    )
}